var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHouseUser = function SvgHouseUser(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M17.994 10.988c.531 0 1-.438 1-1.004.031-.28-.094-.53-.344-.75L17 7.781V4c0-.553-.447-1-1-1h-1c-.553 0-1 .447-1 1v1.147l-3.328-2.928A1.04 1.04 0 0 0 10.016 2c-.22 0-.47.031-.688.25L1.313 9.234a1.02 1.02 0 0 0-.313.75.99.99 0 0 0 1 1.004h1V16c0 1.103.897 2 2 2h10.016c1.109 0 2.006-.9 2-2.01l-.022-5.006h1zM10 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4m-3.5 7.5A2.5 2.5 0 0 1 9 12h2a2.5 2.5 0 0 1 2.5 2.5c0 .275-.225.5-.5.5H7a.5.5 0 0 1-.5-.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHouseUser);
export default ForwardRef;